import 'reflect-metadata';
import p5 from 'p5';
import './sketch';

// Initialize p5 in global mode
new p5();
